import { all, takeLatest, call, put } from "redux-saga/effects";
import api from "../../../services/api";
import { updateAgendamento, updateHorariosDisponiveis, updateComponent } from "./actions";
import types from "./types";

export function* getHorariosDisponiveis(dados) {
    try {
        // Atualizar o estado para "carregando"
        yield put(updateComponent({ loading: true, error: null }));

        const response = yield call(api.post, `/agendamento/dias-disponiveis/${dados.colaboradorId}`, {
            "salaoId": "65dd03bc0f0818dcf7450321"
        });

        if (response.data.error) {
            throw new Error("Erro ao buscar colaboradores: " + response.data.message);
        }

        // Atualizar a lista de colaboradores
        console.log(response.data.agenda)
        yield put(updateHorariosDisponiveis(response.data.agenda));
    } catch (err) {
        console.error(err);
        // Atualizar o estado de erro
        yield put(updateComponent({ loading: false, error: "Erro ao carregar os colaboradores." }));
    }
}

export default all([
    takeLatest(types.GET_HORARIOS_DISPONIVEIS, getHorariosDisponiveis),
]);
